/**
 * API wrapper for the Serienleistungen module (Phase 5 Stufe I, Slice 6,
 * 2026-05-03). Wiederkehrende Aufträge mit festem Turnus pro Objekt
 * (Treppenhausreinigung, Winterdienst, Grünflächenpflege, sonstige).
 * Tägliche Cron erzeugt pro fälliger Serie genau einen Auftrag und
 * verschiebt `naechsteFaelligkeit` um eine Periode weiter.
 */
import { api } from './api';

export type SerienleistungTyp =
  | 'reinigung_treppenhaus'
  | 'winterdienst'
  | 'gruenflaeche'
  | 'sonstige';
export const SERIENLEISTUNG_TYPEN: readonly SerienleistungTyp[] = [
  'reinigung_treppenhaus',
  'winterdienst',
  'gruenflaeche',
  'sonstige',
];
export const SERIENLEISTUNG_TYP_LABEL: Record<SerienleistungTyp, string> = {
  reinigung_treppenhaus: 'Treppenhausreinigung',
  winterdienst: 'Winterdienst',
  gruenflaeche: 'Grünflächenpflege',
  sonstige: 'Sonstige',
};

export type SerienleistungTurnus = 'woechentlich' | 'vierzehntaegig' | 'monatlich';
export const SERIENLEISTUNG_TURNUS: readonly SerienleistungTurnus[] = [
  'woechentlich',
  'vierzehntaegig',
  'monatlich',
];
export const SERIENLEISTUNG_TURNUS_LABEL: Record<SerienleistungTurnus, string> = {
  woechentlich: 'Wöchentlich',
  vierzehntaegig: '14-tägig',
  monatlich: 'Monatlich',
};

export interface Serienleistung {
  id: string;
  kundeId: string;
  objektId: string;
  bezeichnung: string;
  leistungstyp: SerienleistungTyp;
  turnus: SerienleistungTurnus;
  naechsteFaelligkeit: string;
  aktiv: boolean;
  assignedTo: string | null;
  subunternehmerId: string | null;
  notizen: string | null;
  createdAt: string;
  updatedAt: string;
}

interface CreateSerienleistungInput {
  kundeId: string;
  objektId: string;
  bezeichnung: string;
  leistungstyp: SerienleistungTyp;
  turnus: SerienleistungTurnus;
  naechsteFaelligkeit: string;
  subunternehmerId?: string;
  notizen?: string;
}

interface UpdateSerienleistungInput {
  bezeichnung?: string;
  leistungstyp?: SerienleistungTyp;
  turnus?: SerienleistungTurnus;
  naechsteFaelligkeit?: string;
  subunternehmerId?: string;
  notizen?: string;
  aktiv?: boolean;
}

export const serienleistungenApi = {
  async list(opts: { aktivOnly?: boolean } = {}): Promise<{ items: Serienleistung[] }> {
    const qs = opts.aktivOnly ? '?aktivOnly=true' : '';
    return api<{ items: Serienleistung[] }>(`/api/v1/serienleistungen${qs}`);
  },

  async getById(id: string): Promise<{ item: Serienleistung }> {
    return api<{ item: Serienleistung }>(`/api/v1/serienleistungen/${id}`);
  },

  async create(input: CreateSerienleistungInput): Promise<{ item: Serienleistung }> {
    return api<{ item: Serienleistung }>('/api/v1/serienleistungen', {
      method: 'POST',
      body: input,
    });
  },

  async update(id: string, input: UpdateSerienleistungInput): Promise<{ item: Serienleistung }> {
    return api<{ item: Serienleistung }>(`/api/v1/serienleistungen/${id}`, {
      method: 'PATCH',
      body: input,
    });
  },
};
